import ReactGA from 'react-ga4';

const useAnalyticsEventTracker = (category = '', action = '', label = '') => {
  const eventTracker = (action, label) => {
    ReactGA.event({ category, action, label });
  };
  return eventTracker;
};
export default useAnalyticsEventTracker;
